import { defineMessages } from 'react-intl';

export const messages: {
	improveSearch: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	improveSearch: {
		id: 'search-page.app-filter-sidebar.improve-search',
		defaultMessage: 'Improve search',
		description: 'Label that links to a CTA to give feedback',
	},
});
